import { Dictionary } from "flow/api/types";

let meta: Dictionary = {};

function add(metaConfig: Dictionary): void {
    addToNode(meta, metaConfig);
}

function addSingleValue(fullKey: string, value: string | number | boolean) {
    const keyParts = fullKey.split(".");
    const [lastPart] = keyParts.splice(keyParts.length - 1, 1);
    const initialValue = { [lastPart]: value };
    const metaConfig = keyParts.reduceRight<Dictionary>(
        (partialConfig, part) => ({ [part]: partialConfig }),
        initialValue
    );
    add(metaConfig);
}

function clear(): void {
    meta = {};
}

function addToNode(node: Dictionary, nodeToAdd: Dictionary): void {
    Object.keys(nodeToAdd).forEach(key => {
        const lowKey = key.toLowerCase();

        if (isComplex(nodeToAdd[key])) {
            if (node[lowKey] === undefined || !isComplex(node[lowKey])) {
                node[lowKey] = {}; // Object takes precedence over primitive value
            }
            addToNode(node[lowKey], nodeToAdd[key]);
        } else {
            if (node[lowKey] === undefined || !isComplex(node[lowKey])) {
                // Leaf node
                node[lowKey] = nodeToAdd[key];
            }
        }
    });
}

function isComplex(node: any): boolean {
    return typeof node === "object" && node !== null && !(node instanceof Date);
}

export function lookup<T = any>(key: string, defaultValue?: T, ...parameterValues: (string | number | boolean)[]): T;
export function lookup<T = any>(key: string, defaultValue?: T, parameterValueObj?: Dictionary): T;
export function lookup<T = any>(key: string, defaultValue?: T, ...params: any[]): T {
    if (key === undefined || key === null) {
        return defaultValue;
    }

    const parts = key.toLowerCase().split(".");

    let node = meta;

    for (let i = 0; i < parts.length; i++) {
        node = node[parts[i]];
        if (node === undefined) {
            return defaultValue;
        }
    }

    if (params?.length && typeof node == "string") {
        const firstArg = params[0];
        const values = typeof firstArg !== "object" ? params : firstArg;

        node = (node as string).replace(/{([a-zA-Z0-9$_]+)}/g, (match, number) => {
            return values[number] !== undefined ? values[number] : match;
        }) as unknown;
    }

    return node as T;
}

function translate(key: string): any {
    return lookup(key, key);
}

export default {
    add: add,
    addSingleValue: addSingleValue,
    clear: clear,
    lookup: lookup,
    translate: translate
};
